export default "__VITE_ASSET__govjsKey__"